/*
 * @Description: cookies封装
 */
import Keys from '@/constant/key'
import Cookies from 'js-cookie'

export const getToken = () => Cookies.get(Keys.tokenKey)
export const setToken = (token: string,expires?:number) => Cookies.set(Keys.tokenKey, token,{expires})
export const removeToken = () => Cookies.remove(Keys.tokenKey)
